import ListItemSelector from "@shared/components/application/form/ListItemSelector/ListItemSelector.web";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";
import AssignedSeatInformation from "@shared/modules/seating/components/AssignedSeatInformation/AssignedSeatInformation.web";
import { SeatingEventPropertyMap } from "@shared/modules/seating/types/seating-property-types";

const ItemSelectModalSelectCustomerScreen = ({
  seatingEvent,
  itemGroups,
  customerSelected,
  handleSelectCustomer,
  handleUnselectCustomer,
}: {
  seatingEvent: SeatingEventPropertyMap;
  itemGroups: TicketItemGroupType[];
  customerSelected: TicketItemGroupType | null;
  handleSelectCustomer: (itemGroup: TicketItemGroupType) => void;
  handleUnselectCustomer: () => void;
}) => {
  return (
    <Flex direction="column" overflow="auto">
      <>
        {itemGroups?.map((itemGroup, index) => (
          <ListItemSelector
            key={itemGroup.id}
            isDisabled={Boolean(
              customerSelected && customerSelected.id !== itemGroup.id
            )}
            bgColor="bg"
            variant="secondary"
            border="2px solid"
            mb={index === itemGroups.length - 1 ? "0px" : "16px"}
            data-testid={`item-group-index-${index}`}
            checkboxLabel={
              <Flex direction="column">
                <Text fontSize="md" fontWeight="bold">
                  {itemGroup.renewal_member_info?.username}
                </Text>
                {(itemGroup.location_permissions?.[0]?.location ||
                  itemGroup.permissions?.[0]?.seat) && (
                  <>
                    <Text fontSize="sm">{seatingEvent.name}</Text>
                    <Text fontSize="sm" color="gray.600">
                      {
                        seatingEvent.membership_levels.find(
                          (ml) => ml.id === itemGroup.membership_level
                        )?.name
                      }
                    </Text>
                    {itemGroup.renewal_member_info?.original_seat && (
                      <Box
                        backgroundColor="gray.200"
                        borderRadius="sm"
                        padding="4px 8px"
                        display="flex"
                      >
                        <AssignedSeatInformation
                          identifier={
                            itemGroup.location_permissions?.[0]?.location
                              ?.identifier ||
                            itemGroup.permissions?.[0]?.seat?.identifier
                          }
                          segment_identifier={
                            itemGroup.location_permissions?.[0]?.location
                              ?.segment_identifier ||
                            itemGroup.permissions?.[0]?.seat?.segment_identifier
                          }
                          location_identifier={
                            itemGroup.location_permissions?.[0]?.location
                              ?.location_identifier ||
                            itemGroup.permissions?.[0]?.seat
                              ?.location_identifier
                          }
                          isAccessible={
                            itemGroup.permissions?.[0]?.seat?.is_accessible
                          }
                        />
                      </Box>
                    )}
                  </>
                )}
              </Flex>
            }
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.checked
                ? handleSelectCustomer(itemGroup)
                : handleUnselectCustomer()
            }
          />
        ))}
      </>
    </Flex>
  );
};

export default ItemSelectModalSelectCustomerScreen;
